
<div class="categories-container mt-1 {{tema}}">
  <div class="category cpointer ct-point" *ngFor="let categoria of categorias" (click)="selecionou(categoria)">
    <div class="overlay" *ngIf="!categoria.imagem "></div>
    <img [src]="'/images/empresa/' + (categoria.imagem || 'categoria-padrao.png')" alt="{{categoria.nome}}">
    <div class="category-description">{{categoria.nome}}</div>
  </div>
</div>





